/**
 * /herramientas-gratuitas — hub listing every free tool. Server injects SEO
 * for crawlers; this effect covers SPA navigation.
 */
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home, Sparkles } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { SiteFooter } from '../components/SiteFooter';
import { TOOLS } from '../lib/tools';

export function Tools() {
  useEffect(() => {
    const prev = document.title;
    document.title = 'Herramientas gratis para redes sociales · Zettapost';
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Navbar />

      <section className="relative overflow-hidden bg-gradient-to-br from-white via-brand-50/40 to-white border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
          <nav aria-label="Breadcrumbs" className="text-xs text-slate-500">
            <ol className="inline-flex items-center gap-1.5">
              <li>
                <Link to="/" className="inline-flex items-center gap-1 hover:text-slate-900 transition">
                  <Home size={11} />
                  Inicio
                </Link>
              </li>
              <li className="text-slate-300">/</li>
              <li className="text-slate-700">Herramientas gratis</li>
            </ol>
          </nav>
          <h1 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-slate-900 max-w-3xl">
            Herramientas gratis para redes sociales
          </h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed max-w-2xl">
            Generadores con IA y utilidades para creadores, community managers y negocios. Sin registro, sin instalar nada.
          </p>
        </div>
      </section>

      <section>
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {TOOLS.map((tool) => {
              const Icon = tool.icon;
              return (
                <Link
                  key={tool.slug}
                  to={`/herramientas-gratuitas/${tool.slug}`}
                  className="group flex flex-col rounded-2xl border border-slate-200 bg-white p-5 hover:border-brand-300 hover:shadow-md transition"
                >
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-lg bg-brand-50 text-brand-700 inline-flex items-center justify-center">
                      <Icon size={18} />
                    </div>
                    <span className="text-xs font-semibold uppercase tracking-wider text-brand-600">{tool.eyebrow}</span>
                  </div>
                  <h2 className="mt-3 font-semibold text-slate-900 group-hover:text-brand-700 transition">{tool.title}</h2>
                  <p className="mt-1.5 text-sm text-slate-500 leading-relaxed flex-1">{tool.shortDescription}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-brand-600 group-hover:text-brand-700">
                    Abrir herramienta
                    <ArrowRight size={13} className="transition group-hover:translate-x-0.5" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-slate-50 border-t border-slate-200">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
          <div className="rounded-3xl bg-gradient-to-br from-brand-600 to-brand-800 text-white p-8 lg:p-12 text-center">
            <Sparkles size={28} className="mx-auto opacity-90" />
            <h2 className="mt-3 text-2xl lg:text-3xl font-bold">¿Listo para pasar al siguiente nivel?</h2>
            <p className="mt-2 text-brand-100 max-w-xl mx-auto">
              Programa y publica en todas tus redes desde un solo sitio, con IA y link in bio. 3 días gratis.
            </p>
            <Link
              to="/register"
              className="mt-6 inline-flex items-center gap-1.5 rounded-lg bg-white text-brand-700 font-semibold px-5 py-2.5 hover:bg-brand-50 transition"
            >
              Crear cuenta gratis
              <ArrowRight size={15} />
            </Link>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
